import { atom } from 'jotai';
import { PatientInfo } from '../../../../ts';
// import { patientsAtom } from './patients-atoms';
// import { defaultSelectedPatient, notFoundPatient } from '../../../../consts';
// import { selectAtom } from 'jotai/vanilla/utils';
// import deepEquals from 'fast-deep-equal';
// import { allQuotesAtom } from './getters';
import { selectedPatientBaseAtom } from './selected-patient-base-atom';
import { selectedPatientReportsAtom } from './selected-patient-reports-atom';

export const selectedPatientIdAtom = atom<PatientInfo['id'] | null>(null);

// const selectedPatientFinderAtom = atom<PatientInfo>(get => {
//   const allQuotes = get(allQuotesAtom);
//   const patients = get(patientsAtom);
  
//   const selectedPatientId = get(selectedPatientIdAtom);
//   if (patients.length === 0 || selectedPatientId == null) return defaultSelectedPatient;

//   const newSelectedPatient = patients.find(patient => patient.id === selectedPatientId) || notFoundPatient;

//   newSelectedPatient.reportsDetails = allQuotes?.filter(quote => {
//     console.log('comparation patient id and quote.patientid ', quote.Contact_Name.id === selectedPatientId, quote.Contact_Name.id, selectedPatientId);
//     if(quote.Contact_Name.id === selectedPatientId) return quote;
//   });

//   return newSelectedPatient;
// });

export const selectedPatientAtom = atom(get => {
  const patient = get(selectedPatientBaseAtom);
  const reportsDetails = get(selectedPatientReportsAtom);

  return {
    ...patient,
    reportsDetails,
  };
});

// This atom makes a deep comparison between the previous and the new selected patient
// This is helpful to not update state when the selectedPatientIdAtom or the patientsAtom change but the selected patient keeps the same properties
// export const selectedPatientAtom = selectAtom(selectedPatientFinderAtom, sp => sp, (a, b) => {
//    const equal = deepEquals(a, b)
//    console.log('Comparando pacientes:', a.id, '==', b.id, '| iguales:', equal);
//    return equal;
//   });
